import { useContext, useEffect, useRef, type RefObject } from 'react';
import { ViewSnapshotContext, type SourceFrame } from './viewSnapshotContext';

/**
 * Offers a view's own capture to the screenshot of the screen it is on, while
 * it is the one showing. Does nothing outside a {@link ViewSnapshotProvider}.
 */
export const useSnapshotSource = (
  elementRef: RefObject<HTMLElement | null>,
  kind: string,
  capture: () => SourceFrame | Promise<SourceFrame>,
  showing: boolean,
) => {
  const registry = useContext(ViewSnapshotContext);
  const captureRef = useRef(capture);
  useEffect(() => {
    captureRef.current = capture;
  }, [capture]);

  useEffect(() => {
    if (!registry || !showing) return undefined;
    const source = { elementRef, kind, capture: () => captureRef.current() };
    registry.sources.add(source);
    return () => {
      registry.sources.delete(source);
    };
  }, [registry, elementRef, kind, showing]);
};
